module.exports = __webpack_public_path__ + "img/1.a4322d94.jpg";